export default "__VITE_ASSET__E$M8DrsU__"